module.exports = __webpack_public_path__ + "static/fonts/BebasNeue-Regular.47f711bd.ttf";